// Auto-generado por @xone-web/staticweb.
// Concatenación de los JS includes del proyecto (orden importa).
// @ts-nocheck — el contenido es JS XOne sin anotaciones de tipo.

// ===== funciones.js =====
/* ============================================
   DASHBOARD KPI - FUNCIONES GLOBALES
   Compatible mobile (SQLite) + web (REST)
   ============================================ */

// --- NAVEGACION ---
function cerrarPantalla() {
    var w = ui.getView(self);
    if (w) w.exit();
}

function abrirPantalla(nombre) {
    ui.openMenu(nombre, self);
}

// --- MENSAJES ---
function mostrarToast(texto) {
    ui.showToast({
        color: "#323232",
        duration: "short",
        text: texto,
        textColor: "#FFFFFF",
        rounded: true
    });
}

function mostrarToastExito(texto) {
    ui.showToast({
        color: "#2E7D32",
        duration: "short",
        text: texto,
        textColor: "#FFFFFF",
        rounded: true
    });
}

function mostrarToastError(texto) {
    ui.showToast({
        color: "#D32F2F",
        duration: "short",
        text: texto,
        textColor: "#FFFFFF",
        rounded: true
    });
}

function confirmar(mensaje, titulo) {
    var r = ui.msgBox(mensaje, titulo, 4);
    return (r == 6);
}

function mostrarCargando(texto) {
    ui.showWaitDialog(texto || "Cargando...");
}

function ocultarCargando() {
    ui.hideWaitDialog();
}

// --- VALIDACIONES ---
function validarRequerido(valor, campo) {
    if (!valor || valor.toString().trim() === "") {
        mostrarToastError("El campo " + campo + " es obligatorio");
        return false;
    }
    return true;
}

// --- FORMATO ---
function formatearMoneda(valor) {
    if (!valor && valor !== 0) return "0,00";
    var n = parseFloat(valor);
    if (isNaN(n)) return "0,00";
    var parts = n.toFixed(2).split(".");
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return intPart + "," + parts[1];
}

function formatearNumero(valor) {
    if (!valor && valor !== 0) return "0";
    var n = parseInt(valor);
    if (isNaN(n)) return "0";
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function formatearPorcentaje(valor) {
    if (!valor && valor !== 0) return "0%";
    return parseFloat(valor).toFixed(1) + "%";
}

function formatearFecha(fecha) {
    if (!fecha) return "";
    var d = new Date(fecha);
    var dia = ("0" + d.getDate()).slice(-2);
    var mes = ("0" + (d.getMonth() + 1)).slice(-2);
    var anio = d.getFullYear();
    return dia + "/" + mes + "/" + anio;
}

// --- UTILIDADES ---
function cnum(valor) {
    if (!valor && valor !== 0) return 0;
    var n = parseFloat(valor);
    return isNaN(n) ? 0 : n;
}

function cstr(valor) {
    if (!valor && valor !== 0) return "";
    return valor.toString();
}

function obtenerMesActual() {
    var meses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio",
                 "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
    return meses[new Date().getMonth()];
}

function obtenerAnioActual() {
    return new Date().getFullYear();
}

function calcularVariacion(actual, anterior) {
    if (!anterior || anterior == 0) return 0;
    return ((actual - anterior) / anterior) * 100;
}

function textoVariacion(porcentaje) {
    var signo = porcentaje >= 0 ? "+" : "";
    return signo + porcentaje.toFixed(1) + "%";
}

// --- LOGIN ---
function realizarLogin() {
    if (!validarRequerido(self.MAP_LOGIN, "Usuario")) return;
    if (!validarRequerido(self.MAP_PASSWORD, "Contrasena")) return;

    mostrarCargando("Verificando credenciales...");

    appData.login({
        userName: cstr(self.MAP_LOGIN),
        password: cstr(self.MAP_PASSWORD)
    });
}

function cerrarSesion() {
    if (confirmar("Cerrar sesion?", "Confirmar")) {
        appData.setGlobalMacro("##USERID##", "");
        appData.setGlobalMacro("##USERNAME##", "");
        appData.exit();
    }
}

// --- KPIs DASHBOARD PRINCIPAL ---
async function cargarKPIs() {
    var totalVentas = 0;
    var totalGastos = 0;
    var numEmpleados = 0;
    var numClientes = 0;
    var alertasStock = 0;

    totalVentas = await sumarColeccion("Ventas", "TOTAL");
    totalGastos = await sumarColeccion("Gastos", "IMPORTE");
    numEmpleados = await contarColeccion("Empleados", "ACTIVO=1");
    numClientes = await contarColeccion("Clientes", "ACTIVO=1");
    alertasStock = await contarColeccion("Productos", "");

    var margen = 0;
    if (totalVentas > 0) {
        margen = ((totalVentas - totalGastos) / totalVentas) * 100;
    }

    self.MAP_KPI_VENTAS = formatearMoneda(totalVentas);
    self.MAP_KPI_GASTOS = formatearMoneda(totalGastos);
    self.MAP_KPI_MARGEN = margen.toFixed(1) + "%";
    self.MAP_KPI_EMP = formatearNumero(numEmpleados);
    self.MAP_KPI_CLI = formatearNumero(numClientes);
    self.MAP_KPI_STK = formatearNumero(alertasStock);
    self.MAP_KPI_VENTAS_VAR = textoVariacion(calcularVariacion(totalVentas, 0));
    self.MAP_KPI_GASTOS_VAR = textoVariacion(calcularVariacion(totalGastos, 0));

    var userName = appData.getGlobalMacro("##USERNAME##");
    if (userName) {
        self.MAP_SALUDO = "Hola, " + userName;
    }
}

// --- KPIs VENTAS ---
async function cargarKPIVentas() {
    var totalVentas = 0;
    var numVentas = 0;
    var ticketMedio = 0;

    totalVentas = await sumarColeccion("Ventas", "TOTAL");
    numVentas = await contarColeccion("Ventas", "");
    ticketMedio = numVentas > 0 ? totalVentas / numVentas : 0;

    self.MAP_KV_TOTAL = formatearMoneda(totalVentas);
    self.MAP_KV_NUM = formatearNumero(numVentas);
    self.MAP_KV_TICKET = formatearMoneda(ticketMedio);
    self.MAP_KV_TOTAL_V = textoVariacion(calcularVariacion(totalVentas, 0));
}

// --- KPIs GASTOS ---
async function cargarKPIGastos() {
    var totalGastos = 0;
    var totalPresupuesto = 0;
    var usoPpto = 0;

    totalGastos = await sumarColeccion("Gastos", "IMPORTE");
    totalPresupuesto = await sumarColeccion("Departamentos", "PRESUPUESTO");
    usoPpto = totalPresupuesto > 0 ? (totalGastos / totalPresupuesto) * 100 : 0;

    self.MAP_KG_TOTAL = formatearMoneda(totalGastos);
    self.MAP_KG_PPTO = usoPpto.toFixed(1) + "%";
    self.MAP_KG_TOTAL_V = textoVariacion(calcularVariacion(totalGastos, 0));
}

// --- KPIs PERSONAL ---
async function cargarKPIPersonal() {
    var numEmpleados = 0;
    var totalSalarios = 0;
    var salarioMedio = 0;

    numEmpleados = await contarColeccion("Empleados", "ACTIVO=1");
    totalSalarios = await sumarColeccionFiltrada("Empleados", "SALARIO", "ACTIVO=1");
    salarioMedio = numEmpleados > 0 ? totalSalarios / numEmpleados : 0;

    self.MAP_KP_TOTAL = formatearNumero(numEmpleados);
    self.MAP_KP_COSTE = formatearMoneda(totalSalarios);
    self.MAP_KP_MEDIO = formatearMoneda(salarioMedio);
}

// --- FUNCIONES DE AGREGACION ---
async function sumarColeccion(nombreColl, campo) {
    var total = 0;
    var coll = appData.getCollection(nombreColl);
    await coll.loadAll();
    await coll.startBrowse();
    while (!coll.isEOF()) {
        var item = coll.getCurrentItem();
        if (item) {
            total = total + cnum(item[campo]);
        }
        await coll.moveNext();
    }
    await coll.endBrowse();
    return total;
}

async function sumarColeccionFiltrada(nombreColl, campo, filtro) {
    var total = 0;
    var coll = appData.getCollection(nombreColl);
    if (filtro) coll.setFilter(filtro);
    await coll.loadAll();
    await coll.startBrowse();
    while (!coll.isEOF()) {
        var item = coll.getCurrentItem();
        if (item) {
            total = total + cnum(item[campo]);
        }
        await coll.moveNext();
    }
    await coll.endBrowse();
    if (filtro) coll.setFilter("");
    return total;
}

async function contarColeccion(nombreColl, filtro) {
    var coll = appData.getCollection(nombreColl);
    if (filtro) coll.setFilter(filtro);
    await coll.loadAll();
    var count = await coll.startBrowse(true);
    if (filtro) coll.setFilter("");
    return count;
}

// --- OPERACIONES CRUD ---
async function nuevaVenta() {
    try {
        var coll = appData.getCollection("Ventas");
        var obj = await coll.createObject();
        if (obj) {
            obj.FECHA = new Date();
            obj.ESTADO = "Pendiente";
            ui.openEditView(obj);
        }
    } catch(e) {
        mostrarToastError("Error al crear venta");
    }
}

async function nuevoGasto() {
    try {
        var coll = appData.getCollection("Gastos");
        var obj = await coll.createObject();
        if (obj) {
            obj.FECHA = new Date();
            obj.ESTADO = "Pendiente";
            ui.openEditView(obj);
        }
    } catch(e) {
        mostrarToastError("Error al crear gasto");
    }
}

async function guardarCliente() {
    if (!validarRequerido(self.MAP_NOMBRE_FORM, "Nombre")) return;

    self.NOMBRE = self.MAP_NOMBRE_FORM;
    self.EMAIL = self.MAP_EMAIL_CLI;
    self.TELEFONO = self.MAP_TEL_CLI;
    self.DIRECCION = self.MAP_DIR_CLI;
    self.CIUDAD = self.MAP_CIUDAD_CLI;
    self.ACTIVO = self.MAP_ACTIVO_CLI;

    try {
        await self.save();
        mostrarToastExito("Cliente guardado");
    } catch(e) {
        mostrarToastError("Error al guardar: " + e);
    }
}

// ===== exports para MPA Island mode =====
export { cerrarPantalla, abrirPantalla, mostrarToast, mostrarToastExito, mostrarToastError, confirmar, mostrarCargando, ocultarCargando, validarRequerido, formatearMoneda, formatearNumero, formatearPorcentaje, formatearFecha, cnum, cstr, obtenerMesActual, obtenerAnioActual, calcularVariacion, textoVariacion, realizarLogin, cerrarSesion, cargarKPIs, cargarKPIVentas, cargarKPIGastos, cargarKPIPersonal, sumarColeccion, sumarColeccionFiltrada, contarColeccion, nuevaVenta, nuevoGasto, guardarCliente };
